// extracted by mini-css-extract-plugin
export var deliveryRow = "_qo-a";
export var fixedHeight = "_qo-4";
export var freightLogo = "_qo-9";
export var fullWidth = "_qo-3";
export var priceColumn = "_qo-5";
export var radioSelected = "_qo-7";
export var radioUnselected = "_qo-6";
export var selectedOption = "_qo-2";
export var selectedOptionContainer = "_qo-1";
export var selection = "_qo-0";
export var tallSkeletonText = "_qo-8";